import React from 'react';
import classNames from 'classnames';
import { useField } from 'formik';

import T from '../Translate';

interface SharedProps {
  className?: string;
}

interface FieldProps extends SharedProps {
  name: string;
}

export default function FieldValidationMessage(props: FieldProps) {
  const [, meta] = useField(props.name);
  const show = meta.error && (meta.touched || typeof meta.initialValue === 'boolean');

  return <ValidationMessage className={props.className} message={meta.error} show={show} />;
}

interface Props extends SharedProps {
  show?: boolean;
  message?: string;
}

export function ValidationMessage({ show, message, className }: Props) {
  return (
    <div className={classNames('invalid-feedback', { visible: show }, className)}>
      <T id={message} optional />
    </div>
  );
}
